var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[(_vm.active)?_c('router-link',{staticClass:"nav-link active",attrs:{"to":_vm.url}},[_c('i',{class:'nav-icon '+_vm.icon}),_c('p',[_vm._v(_vm._s(_vm.title))])]):_c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.url}},[_c('i',{class:'nav-icon '+_vm.icon}),_c('p',[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }